/**
 * URL Sanitizer Utility
 * Prevents XSS attacks via javascript: protocol and other malicious URLs
 */

export const sanitizeUrl = (url: string | undefined | null): string => {
  if (!url) return '#';
  
  try {
    // Trim whitespace
    const trimmedUrl = url.trim();
    
    // Handle empty strings
    if (!trimmedUrl) return '#';
    
    // Add protocol if missing
    const urlWithProtocol = trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://') 
      ? trimmedUrl 
      : `https://${trimmedUrl}`;
    
    // Parse URL to validate
    const parsed = new URL(urlWithProtocol);
    
    // Only allow http and https protocols
    if (!['http:', 'https:'].includes(parsed.protocol)) {
      console.warn(`Blocked potentially malicious URL protocol: ${parsed.protocol}`);
      return '#';
    }
    
    return parsed.href;
  } catch (error) {
    // Invalid URL
    console.warn(`Invalid URL sanitized: ${url}`);
    return '#';
  }
};

/**
 * Sanitize email links
 */
export const sanitizeEmail = (email: string | undefined | null): string => {
  if (!email) return '#';
  
  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    console.warn(`Invalid email sanitized: ${email}`);
    return '#';
  }
  
  return `mailto:${email}`;
};

/**
 * Sanitize tel links
 */
export const sanitizeTel = (tel: string | undefined | null): string => {
  if (!tel) return '#';
  
  // Remove non-numeric characters except +, -, and spaces
  const cleaned = tel.replace(/[^0-9+\-\s]/g, '');
  
  if (!cleaned) return '#';
  
  return `tel:${cleaned}`;
};